import React, { useEffect, useState } from 'react'
import styles from './styles/checkbox-input.module.scss'
import cx from 'classnames'
import { ClassNameProps, ClassNamesProps } from 'types/utilities'

type ClassKeys = 'wrapper' | 'checkbox' | 'label' | 'secondaryLabel'

interface Props extends ClassNameProps, ClassNamesProps<ClassKeys> {
  onClick: any
  label: string
  secondaryLabel?: string
  isChecked: boolean
  children?: any
  isDisabled?: boolean
  asOption?: true
  ariaSetsize?: number
  ariaSelected?: boolean
}

const CheckboxInput: React.FC<Props> = ({
  onClick,
  label,
  secondaryLabel,
  isChecked,
  children,
  isDisabled = false,
  asOption,
  className,
  classNames,
  ariaSetsize,
  ariaSelected,
}) => {
  const [isSelected, setIsSelected] = useState<boolean>(isChecked)
  const [isFocused, setIsFocused] = useState(false)
  const handleCheckBoxClick = () => {
    if (!isDisabled) {
      onClick()
      setIsSelected(prev => !prev)
    }
  }

  useEffect(() => {
    setIsSelected(isChecked)
  }, [isChecked])

  return (
    <div
      id={asOption ? label : undefined}
      className={cx(styles.checkboxInput, className, classNames?.wrapper, {
        [styles.checked]: isSelected,
        [styles.disabled]: isDisabled,
        '--is-focused': isFocused,
      })}
      onClick={handleCheckBoxClick}
      role={asOption && 'option'}
      aria-selected={ariaSelected}
      aria-checked={asOption ? isSelected : undefined}
      aria-setsize={ariaSetsize}
    >
      <input
        role={asOption ? 'presentation' : undefined}
        tabIndex={asOption ? -1 : 0}
        disabled={isDisabled}
        type='checkbox'
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={cx(classNames?.checkbox)}
        aria-checked={isSelected}
      />
      <label className={cx(classNames?.label)}>
        {label}
        {secondaryLabel && (
          <>
            {' '}
            <span className={cx(styles.secondaryLabel, classNames?.secondaryLabel)}>
              {secondaryLabel}
            </span>
          </>
        )}
      </label>
      {children}
    </div>
  )
}

export default CheckboxInput
